import classNames from 'classnames/bind';
import { DIMENSION, useAvailableItems, useDimension } from '../../../../hooks';
import { isSponsoredAccount, isVideoAccount } from '../../../../modules/account-management';
import { ENTITY } from '../../../../modules/campaigns/config';
import { AllEntityId } from '../../../../modules/campaigns/config/allEntityId';
import { PICKER_ENTITY } from '../../../../modules/campaigns/hooks/useEntityPickerType';
import { REPORT_ENTITY_IDS } from '../../../../modules/campaigns/hooks/useReportEntityIds';
import { useAccount } from '../../../../modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from '../../../../modules/taboola-common-frontend-modules/i18n';
import { CAMPAIGN_DIMENSION } from '../../../../services/campaignDimension';
import { InternalLink } from '../../../InternalLink';
import styles from './DimensionPicker.module.scss';

const classNameBuilder = classNames.bind(styles);

const dimensions = [
    {
        dimension: CAMPAIGN_DIMENSION.SPONSORED,
        label: <FormattedMessage id={`app.breadcrumbs.dimension.${CAMPAIGN_DIMENSION.SPONSORED}`} />,
        visibilityCondition: ({ account }) => isSponsoredAccount(account.partnerTypes),
    },
    {
        dimension: CAMPAIGN_DIMENSION.VIDEO,
        label: <FormattedMessage id={`app.breadcrumbs.dimension.${CAMPAIGN_DIMENSION.VIDEO}`} />,
        visibilityCondition: ({ account }) => isVideoAccount(account.partnerTypes),
    },
];

export const DimensionPicker = ({ children }) => {
    const account = useAccount();
    const [selectedDimension] = useDimension();
    const availableDimensions = useAvailableItems(dimensions, { account });

    return (
        <div className={styles['container']}>
            {availableDimensions.length > 1 && (
                <div className={styles['dimensions']}>
                    {availableDimensions.map(({ dimension, label }) => (
                        <InternalLink
                            key={dimension}
                            className={classNameBuilder(['dimension-link'], {
                                active: dimension === selectedDimension,
                            })}
                            disabled={dimension === selectedDimension}
                            params={{
                                [DIMENSION]: dimension,
                                [REPORT_ENTITY_IDS]: AllEntityId,
                                [PICKER_ENTITY]: ENTITY.CAMPAIGN,
                            }}
                        >
                            {label}
                        </InternalLink>
                    ))}
                </div>
            )}
        </div>
    );
};
